import { noop } from 'remeda';
import { ISupplier } from '@bridebook/models/source/models/Suppliers.types';
import EmbeddedMap from '@bridebook/web/app-shared/components/embedded-map/embedded-map';

type Props = {
  supplier: ISupplier;
};

export const Map = ({ supplier }: Props) => {
  const showMap = supplier.address && !supplier.flags?.hideStreet;

  if (!showMap) return null;

  return (
    <div className="w-full max-w-[640px] px-8 @screen-lg:px-0">
      <EmbeddedMap
        onMouseUp={noop}
        onMapInView={noop}
        supplierName={supplier.name}
        supplierCity={supplier.address.city}
        supplierCountry={supplier.address.country}
        supplierPostalCode={supplier.address.postalCode}
      />
    </div>
  );
};
